import { render, staticRenderFns } from "./EditBar.vue?vue&type=template&id=9f97129c&scoped=true"
import script from "./EditBar.vue?vue&type=script&lang=js"
export * from "./EditBar.vue?vue&type=script&lang=js"
import style0 from "./EditBar.vue?vue&type=style&index=0&id=9f97129c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f97129c",
  null
  
)

export default component.exports